import { render } from "./BtnLoginFacebook.vue?vue&type=template&id=05bd9f78"
import script from "./BtnLoginFacebook.vue?vue&type=script&lang=js"
export * from "./BtnLoginFacebook.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__